<div class="reject-final-cost" data-testid="reject-final-cost-content">
  <div
    class="reject-final-cost__warning"
    data-testid="reject-final-cost-warning"
  >
    <img
      class="reject-final-cost__warning-icon"
      src="assets/icons/warning.svg"
      alt=""
      aria-hidden="true"
    />
    <p class="reject-final-cost__warning-text">
      If you reject the final cost at this point, the
      <strong>vendor will charge</strong> only for any file preparation work
      that they have already completed.
    </p>
  </div>

  <button
    type="button"
    class="reject-final-cost__back"
    data-testid="reject-final-cost-back"
    (click)="onBack()"
  >
    <mat-icon class="reject-final-cost__back-icon" aria-hidden="true">
      chevron_left
    </mat-icon>
    <span>Back to final cost preview</span>
  </button>

  <p class="reject-final-cost__message">
    By rejecting this final cost, you will be cancelling the translation job and
    the documents you provided will not be translated. <br /><br />
    Are you sure you want to cancel this translation job?
  </p>
</div>
